export enum MonetizationMode {
  /** Platform keeps a percentage of each customer charge. Default rate: 7.5% (750 bps). */
  Commission = 0,
  /** Artist pays the platform a recurring flat monthly subscription instead of per-charge fees. */
  Subscription = 1,
}
